
import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, FormWhiteContainer, LabelContainer, LightBlueContainer, LongBlueButton, ShortBlueButton, WhiteContainer } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useLocation, useNavigate } from 'react-router';
import TrainingDetailContainer from '../components/Containers/TrainingDetailContainer';
import { v4 as uuidv4 } from 'uuid';
import { workerPageName } from '../components/PageName';
import { useCreateWorkerMutation, useLazyGetWorkerFileQuery, useUpdateWorkerMutation } from '../features/worker/workerSlice';
import { CertificateModel, SafetyRelatedCert, WorkerDetailModel, WorkerModel, trainingDetail, siteDocements } from '../models/WorkerModel';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useTranslation } from "react-i18next";

const AddWorkerPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    const worker = getLocation.state?.worker as WorkerDetailModel;
    const [rfid, setRfid] = useState(worker?.rfidNumber);
    const [workerName, setWorkerName] = useState(worker?.workerName || "");
    const [companyName, setCompanyName] = useState(worker?.companyName || "");
    const [phoneNumber, setPhoneNumber] = useState(worker?.phoneNumber || "");

    const workerPhotoInputRef = useRef<HTMLInputElement>(null);
    const registrationCardFileInputRef = useRef<HTMLInputElement>(null);
    const staffCardFileInputRef = useRef<HTMLInputElement>(null);
    const certifiedConfinedWorkFileInputRef = useRef<HTMLInputElement>(null);
    const [workerPhotoAsFile, setWorkerPhotoAsFile] = useState<File | null>(null);
    const [registrationCardAsFile, setRegistrationCardAsFile] = useState<File | null>(null);
    const [staffCardAsFile, setStaffCardAsFile] = useState<File | null>(null);
    const [certifiedConfinedWorkAsFile, setCertifiedConfinedWorkAsFile] = useState<File | null>(null);

    const [trainingDetailsAsRequestParameter, setTrainingDetailsAsRequestParameter] = useState<CertificateModel[]>([])
    const [addTrainingDetail, setAddTrainingDetail] = useState(false);
    const [isSuccessInitialization, setIsSuccessInitialization] = useState(false)
    const [open, setOpen] = useState(false)
    const [createWorker] = useCreateWorkerMutation()
    const [updateWorker] = useUpdateWorkerMutation()
    const [getWorkerFile, getWorkerFileResult] = useLazyGetWorkerFileQuery()

    // Initization
    useEffect(() => {
        if (!worker) {
            // It is Adding Worker
            setIsSuccessInitialization(true)
            return
        }

        // It is Editing Worker. Load files. We need File objects be sent to the API with the request
        const loadFiles = async function () {
            try {
                if (worker.safetyCardFile?.Id && worker.safetyCardFile?.Name) {
                    const imageUrl = await getWorkerFile(worker.safetyCardFile?.Id).unwrap()
                    const blob = await fetch(imageUrl).then(r => r.blob());
                    const file = new File([blob], worker.safetyCardFile?.Name, { type: worker.safetyCardFile.ContentType });
                    setStaffCardAsFile(file)
                }

                if (worker.workerPhotoFile?.Id && worker.workerPhotoFile?.Name) {
                    const imageUrl = await getWorkerFile(worker.workerPhotoFile?.Id).unwrap()
                    const blob = await fetch(imageUrl).then(r => r.blob());
                    const file = new File([blob], worker.workerPhotoFile?.Name, { type: worker.workerPhotoFile.ContentType });
                    setWorkerPhotoAsFile(file)
                }

                if (worker.registrationCardFile?.Id && worker.registrationCardFile?.Name) {
                    const imageUrl = await getWorkerFile(worker.registrationCardFile?.Id).unwrap()
                    const blob = await fetch(imageUrl).then(r => r.blob());
                    const file = new File([blob], worker.registrationCardFile?.Name, { type: worker.registrationCardFile.ContentType });
                    setRegistrationCardAsFile(file)
                }

                if (worker.certifiedConfinedWorkFile?.Id && worker.certifiedConfinedWorkFile?.Name) {
                    const imageUrl = await getWorkerFile(worker.certifiedConfinedWorkFile?.Id).unwrap()
                    const blob = await fetch(imageUrl).then(r => r.blob());
                    const file = new File([blob], worker.certifiedConfinedWorkFile?.Name, { type: worker.certifiedConfinedWorkFile.ContentType });
                    setCertifiedConfinedWorkAsFile(file)
                }

                const certifications: CertificateModel[] = []
                for (let i = 0; i < worker.trainingDetails.length; i++) {
                    const item = worker.trainingDetails[i]
                    let certificationFile = null
                    if (item.certificationFile?.Id && item.certificationFile?.Name) {
                        const imageUrl = await getWorkerFile(item.certificationFile?.Id).unwrap()
                        const blob = await fetch(imageUrl).then(r => r.blob());
                        const file = new File([blob], item.certificationFile?.Name, { type: item.certificationFile.ContentType });
                        certificationFile = file
                    }
                    certifications.push({
                        trainingDate: item.trainingDate || "",
                        certificationName: item.certificationName || "",
                        certificationFile: certificationFile
                    })
                }
                setTrainingDetailsAsRequestParameter(certifications)
                setIsSuccessInitialization(true)
            } catch (error) {
                setIsSuccessInitialization(false)
                alert("Fails to retrieve files from the server.")
                console.error(error)
            }
        }

        loadFiles()
    }, [])

    const handleDeleteTrainingDetail = (index: number) => {
        return () => {
            setTrainingDetailsAsRequestParameter(prevDetails => {
                return prevDetails.filter((detail, idx) => idx !== index)
            });
        }
    };
    const handleAddTrainingDetail = () => {
        setAddTrainingDetail(true)
    };

    const handleAddNewTrainingDetail = (newWorker: CertificateModel) => {
        const updatedWorker = [...trainingDetailsAsRequestParameter, newWorker];
        setTrainingDetailsAsRequestParameter(updatedWorker);
        setAddTrainingDetail(false)
    };
    const handleEditTrainingDetail = (index: number) => {
        return (updatedTrainingDetail: CertificateModel) => {
            setTrainingDetailsAsRequestParameter(prevDetails => {
                const newDetails = prevDetails.map((detail, idx) => {
                    if (idx == index) {
                        return updatedTrainingDetail
                    } else {
                        return detail
                    }
                })
                return newDetails
            });
        }
    };
    const handleWorkerPhotoFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setWorkerPhotoAsFile(selectedFile)
        }
    };
    const handleRegistrationCardFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setRegistrationCardAsFile(selectedFile)
        }
    };
    const handleStaffCardFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setStaffCardAsFile(selectedFile)
        }
    };
    const handleCertifiedConfinedWorkFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setCertifiedConfinedWorkAsFile(selectedFile)
        }
    };

    const handleWorkerPhotoButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (workerPhotoInputRef.current) {
            workerPhotoInputRef.current.click();
        }
    };

    const handleRegistrationCardButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (registrationCardFileInputRef.current) {
            registrationCardFileInputRef.current.click();
        }
    };

    const handleStaffCardButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (staffCardFileInputRef.current) {
            staffCardFileInputRef.current.click();
        }
    };
    const handleCertificatedCardButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (certifiedConfinedWorkFileInputRef.current) {
            certifiedConfinedWorkFileInputRef.current.click();
        }
    };

    const handleSaveButtonClick = async () => {
        if (worker) {
            // Editing a existing worker
            try {
                const workerPhoto: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: workerPhotoAsFile
                };
                const registrationFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: registrationCardAsFile
                };
                const safetyCardFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: staffCardAsFile
                };
                const certifiedConfinedWorkFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: certifiedConfinedWorkAsFile
                };
                const model: WorkerModel = {
                    rfidNumber: rfid,
                    workerName: workerName,
                    companyName: companyName,
                    workerPhotoFile: workerPhoto,
                    phoneNumber: phoneNumber,
                    registrationCardFile: registrationFile,
                    safetyCardFile: safetyCardFile,
                    certifiedConfinedWorkFile: certifiedConfinedWorkFile,
                    trainingDetails: trainingDetailsAsRequestParameter
                };
                console.log("model, ", model)
                const formData = new FormData();
                formData.append('rfidNumber', model.rfidNumber)
                formData.append('workerName', model.workerName)
                formData.append('companyName', model.companyName)
                formData.append('phoneNumber', model.phoneNumber)
                formData.append('workerPhotoFile.file', model.workerPhotoFile?.file as File)
                formData.append('registrationCardFile.file', model.registrationCardFile?.file as File)
                formData.append('safetyCardFile.file', model.safetyCardFile?.file as File)
                formData.append('certifiedConfinedWorkFile.file', model.certifiedConfinedWorkFile?.file as File)
                model.trainingDetails.forEach((item, index) => {
                    formData.append(`trainingDetails[${index}].trainingDate`, item.trainingDate)
                    formData.append(`trainingDetails[${index}].certificationName`, item.certificationName)
                    formData.append(`trainingDetails[${index}].certificationFile`, item.certificationFile as File)
                })


                await updateWorker({ id: worker.id, formData }).unwrap()
                navigate("/worker-detail", { state: { workerID: worker.id } })

            } catch (error) {
                alert('Fails to update')
                console.error(error)
            }
        } else {
            // Adding a new worker
            try {
                const workerPhoto: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: workerPhotoAsFile
                };
                const registrationFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: registrationCardAsFile
                };
                const safetyCardFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: staffCardAsFile
                };
                const certifiedConfinedWorkFile: siteDocements = {
                    id: "string",
                    name: "string",
                    contentType: "string",
                    type: "string",
                    file: certifiedConfinedWorkAsFile
                };
                const model: WorkerModel = {
                    rfidNumber: rfid,
                    workerName: workerName,
                    companyName: companyName,
                    workerPhotoFile: workerPhoto,
                    phoneNumber: phoneNumber,
                    registrationCardFile: registrationFile,
                    safetyCardFile: safetyCardFile,
                    certifiedConfinedWorkFile: certifiedConfinedWorkFile,
                    trainingDetails: trainingDetailsAsRequestParameter
                };

                console.log("model, ", model)
                const formData = new FormData();
                formData.append('rfidNumber', model.rfidNumber)
                formData.append('workerName', model.workerName)
                formData.append('companyName', model.companyName)
                formData.append('phoneNumber', model.phoneNumber)
                formData.append('workerPhotoFile.file', model.workerPhotoFile?.file as File)
                formData.append('registrationCardFile.file', model.registrationCardFile?.file as File)
                formData.append('safetyCardFile.file', model.safetyCardFile?.file as File)
                formData.append('certifiedConfinedWorkFile.file', model.certifiedConfinedWorkFile?.file as File)
                model.trainingDetails.forEach((item, index) => {
                    formData.append(`trainingDetails[${index}].trainingDate`, item.trainingDate)
                    formData.append(`trainingDetails[${index}].certificationName`, item.certificationName)
                    formData.append(`trainingDetails[${index}].certificationFile`, item.certificationFile as File)
                })
                await createWorker(formData).unwrap()
                navigate("/worker")

            } catch (error) {
                alert('Fails to create')
                console.error(error)
            }
        }
    };

    const getLink = function (file: File | null | undefined) {
        if (file) {
            return <a
                onClick={() => { displayImageInNewTab(file, file.name) }}
                style={{ marginLeft: "10px" }}
                href={"javascript:;"}
                target="_blank"
                rel="noopener noreferrer"
            >
                {file.name}
            </a>
        } else {
            return ""
        }
    }

    const displayImageInNewTab = function (blob: Blob, filename: string) {
        const imageUrl = URL.createObjectURL(blob);
        const newTab = window.open(imageUrl);
    }

    const onClose = function () {
        setOpen(false)
    }

    const openModalConfirmationBox = function () {
        setOpen(true)
    }

    return (
        <MainContent type={workerPageName}>

            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    {!worker && <BigHeading>{t("Add New Worker")}</BigHeading>}
                    {worker && <BigHeading>{t("Edit New Worker")}</BigHeading>}
                    {/* {<FormInput title={t("RFID No.")} value={rfid} setMethod={setRfid} />} */}
                    <FormInput title={t("Worker Name")} value={workerName} setMethod={setWorkerName} />
                    <FormInput title={t("Company Name")} value={companyName} setMethod={setCompanyName} />
                    <FormInput title={t("Phone Number")} value={phoneNumber} setMethod={setPhoneNumber} />
                    {<ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Workers Photo: ")}
                        </LabelContainer>
                        <input type="file" ref={workerPhotoInputRef} onChange={handleWorkerPhotoFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "18px" }} onClick={handleWorkerPhotoButtonClick}>Select File</DocumentButton>
                        {workerPhotoAsFile && getLink(workerPhotoAsFile)}
                        {workerPhotoAsFile &&
                            <IconButton onClick={() => setWorkerPhotoAsFile(null)}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>}
                    <ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Workers Registration Card: ")}
                        </LabelContainer>
                        <input type="file" ref={registrationCardFileInputRef} onChange={handleRegistrationCardFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "18px" }} onClick={handleRegistrationCardButtonClick}>Select File</DocumentButton>
                        {registrationCardAsFile && getLink(registrationCardAsFile)}
                        {registrationCardAsFile &&
                            <IconButton onClick={() => setRegistrationCardAsFile(null)}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>
                    <ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Safety Card: ")}
                        </LabelContainer>
                        <input type="file" ref={staffCardFileInputRef} onChange={handleStaffCardFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "18px" }} onClick={handleStaffCardButtonClick}>Select File</DocumentButton>
                        {staffCardAsFile && getLink(staffCardAsFile)}
                        {staffCardAsFile &&
                            <IconButton onClick={() => setStaffCardAsFile(null)}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>
                    <ButtonContainer>
                        <LabelContainer style={{ marginLeft: "28px" }}>
                            {t("Certified Work of Confined Space Operation: ")}
                        </LabelContainer>
                        <input type="file" ref={certifiedConfinedWorkFileInputRef} onChange={handleCertifiedConfinedWorkFileChange} accept="*" style={{ display: 'none' }} />
                        <DocumentButton style={{ marginLeft: "18px" }} onClick={handleCertificatedCardButtonClick}>Select File</DocumentButton>
                        {certifiedConfinedWorkAsFile && getLink(certifiedConfinedWorkAsFile)}
                        {certifiedConfinedWorkAsFile &&
                            <IconButton onClick={() => { setCertifiedConfinedWorkAsFile(null) }}>
                                <img src={deleteIcon} />
                            </IconButton>
                        }
                    </ButtonContainer>

                    &nbsp;
                    <BigHeading>{t("Training Details")}</BigHeading>
                    <Box sx={{ margin: "8px" }}>
                        <LongBlueButton onClick={handleAddTrainingDetail}>{t("Add Training Detail")}</LongBlueButton>
                    </Box>
                    {addTrainingDetail && <TrainingDetailContainer onAddTrainingDetail={handleAddNewTrainingDetail} onCancel={() => setAddTrainingDetail(false)} />}
                    {trainingDetailsAsRequestParameter.length > 0 ? (
                        trainingDetailsAsRequestParameter.map((trainingDetail, index) => (
                            <Box key={Math.random() + index}>
                                <TrainingDetailContainer
                                    trainingDetail={trainingDetail}
                                    onEditTrainingDetail={handleEditTrainingDetail(index)}
                                    onDelete={handleDeleteTrainingDetail(index)}
                                />
                            </Box>
                        ))
                    ) : (
                        (!addTrainingDetail && <FormWhiteContainer><p style={{ marginLeft: "28px", textAlign: "center" }}>{t("No training details found.")}</p></FormWhiteContainer>)
                    )}

                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={openModalConfirmationBox} disabled={!isSuccessInitialization}>{t("Save")}</ShortBlueButton>
                        <BackButton onClick={() => { navigate('/worker') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>

            {/* Confirmation Box */}
            {
                worker && <ModalConfirmationBox onConfirm={handleSaveButtonClick} onClose={onClose} open={open} description={"Are you sure to update worker record? "} />
            }            {
                !worker && <ModalConfirmationBox onConfirm={handleSaveButtonClick} onClose={onClose} open={open} description={"Are you sure to add new worker? "} />
            }

        </MainContent>
    );
};

export default AddWorkerPage;